/*  imported from Heading.module.scss  */

@import '~@tdcerhverv/sass-utils/_util';
@import '~@tdcerhverv/parrotfish/dist/colors-design-token.scss';

$mq: 61.25rem;

.Heading-module__heading___1VA_G {
  line-height: 1;
  margin: 0;
  padding-bottom: 1.5rem;
  color: map-get($theme, 'black');
}

.Heading-module__heading1___10k5j {
  font-size: 2.5rem;
  padding-bottom: 2rem;

  @media (min-width: $mq) {
    font-size: 2.5rem;
  }
}

.Heading-module__heading2___3dCRC {
  font-size: 2rem;
  padding-bottom: 2rem;

  @media (min-width: $mq) {
    font-size: 2rem;
  }
}

.Heading-module__heading3___KWRPA {
  font-size: 1.5rem;

  @media (min-width: $mq) {
    font-size: 1.5rem;
  }
}

.Heading-module__heading4___226ho {
  font-size: rem(18);
}

.Heading-module__heading5___2SYTC {
  font-size: rem(14);
  letter-spacing: rem(1);
}

.Heading-module__thin___3TiUD {
  font-weight: 100;
}

.Heading-module__regular___2BslH {
  font-weight: 400;
}

.Heading-module__strong___TB2no {
  font-weight: 700;
}

.Heading-module__left___DWiGp {
  text-align: left;
}

.Heading-module__center___3QXKn {
  text-align: center;
}

.Heading-module__right___1HIX6 {
  text-align: right;
}

.Heading-module__justify___9Oijk {
  text-align: justify;
}

.Heading-module__uppercase___xCo0B {
  text-transform: uppercase;
}

.Heading-module__lightColored___mIS1Y {
  color: map-get($theme, 'white');
}
